import React, { forwardRef } from 'react';
import wordmark from '../../../assets/home/logo-wordmark.png';

/*
 * Logo da Idealizer reconstruído para animação: o anel verde vira um path SVG
 * (medido no logo.png original: centro 107,107 · raio 73.3 · abertura de -49° a 40°)
 * e o wordmark é o próprio PNG sem o anel, revelado por um clipPath.
 */
export const LOGO_VIEW = { w: 460, h: 216 };
export const RING = { cx: 107, cy: 107, r: 73.3, stroke: 6.6 };
export const RING_PATH = 'M163.15 154.12 A73.3 73.3 0 1 1 155.09 51.68';

const LogoMark = forwardRef(function LogoMark({ className = '', idPrefix = 'lm' }, ref) {
  const maskId = `${idPrefix}-mask`;
  const gradId = `${idPrefix}-grad`;
  return (
    <svg
      ref={ref}
      className={className}
      viewBox={`0 0 ${LOGO_VIEW.w} ${LOGO_VIEW.h}`}
      role="img"
      aria-label="Idealizer"
    >
      <defs>
        {/* Máscara com borda em degradê: o wordmark surge suave, sem cortar letras ao meio. */}
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#fff" />
          <stop offset="0.7" stopColor="#fff" />
          <stop offset="1" stopColor="#000" />
        </linearGradient>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width={LOGO_VIEW.w} height={LOGO_VIEW.h}>
          <rect className="lm-mask-rect" x="0" y="50" width="700" height="116" fill={`url(#${gradId})`} />
        </mask>
      </defs>
      <image
        className="lm-word"
        href={wordmark}
        width={LOGO_VIEW.w}
        height={LOGO_VIEW.h}
        mask={`url(#${maskId})`}
      />
      <path
        className="lm-ring"
        d={RING_PATH}
        fill="none"
        stroke="#22c55e"
        strokeWidth={RING.stroke}
        strokeLinecap="round"
      />
    </svg>
  );
});

/** Só o anel, para usar como motivo gráfico (separadores, fechamento). */
export function RingGlyph({ className = '', strokeWidth = RING.stroke }) {
  return (
    <svg className={className} viewBox="26 26 162 162" aria-hidden focusable="false">
      <path d={RING_PATH} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
    </svg>
  );
}

export default LogoMark;
